/* globals window */
import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { findDOMNode } from 'react-dom';
import $ from 'jquery';
import displayName from 'component-lib/displayName';

import RetinaImage from './RetinaImage';

import closeIcon from './close-dialog-gray.png';
import styles from './Dialog/Dialog.scss';

// TODO: remove ref usage
/* eslint-disable react/no-find-dom-node, react/no-string-refs */
export default class Dialog extends Component {
    static displayName = displayName('Dialog');

    static propTypes = {
        onClose: PropTypes.func,
        children: PropTypes.any,
    };

    static defaultProps = {
        onClose: () => {},
        children: null,
    };

    componentDidMount() {
        $('body').css('overflow', 'hidden');
    }

    componentWillUnmount() {
        $('body').css('overflow', 'auto');
    }

    close = () => {
        this.props.onClose();
    };

    render() {
        return (
            <div
                ref={(comp) => {
                    $(findDOMNode(comp)).css({
                        top: $(window).scrollTop(),
                        left: $(window).scrollLeft(),
                    });
                }}
                data-dialog
                className={styles.dialog}
            >
                <div className={styles.overlay} />
                <div className={styles['content-wrapper']}>
                    <div className={styles.content}>
                        {this.props.children({
                            close: this.close,
                        })}
                        <span role="presentation" className={styles.close} onClick={this.close}>
                            <RetinaImage image={closeIcon} />
                        </span>
                    </div>
                </div>
            </div>
        );
    }
}
/* eslint-enable */
